import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from "@angular/material/input";
import {MatButtonModule} from '@angular/material/button';

type inputDialog = {
  boxes: itemBox[];
  workOrderId: number;
};

type itemBox = {
  id: number;
  createdAt: string;
  quantity: number;
};

@Component({
  selector: 'app-select-cobot-box',
  templateUrl: './select-cobot-box.component.html',
  styleUrls: ['./select-cobot-box.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule
],
})
export class SelectCobotBoxComponent implements OnInit {
  constructor(
    protected readonly dialogRef: MatDialogRef<SelectCobotBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: inputDialog
  ) {}

  form = new FormGroup(
    {
      selectedBox: new FormControl<itemBox>(undefined),
    },
    {
      validators: [Validators.required],
    }
  );

  ngOnInit(): void {
    this.form.get('selectedBox').setValue(this.boxes[0]);
  }

  get boxes(): itemBox[] {
    return this.dialogData.boxes;
  }

  onClickClose(): void {
    this.dialogRef.close();
  }

  onClickConfirm(): void {
    this.dialogRef.close(this.form.get('selectedBox').value);
  }
}
